/* /pages/moje-konto for visitors who aren't signed in (Aleksandra 1.10): sections/batida-konto-login.liquid.
   "Mam konto" / "Pierwszy raz" switch the texts; the button opens Shopify's code page with the e-mail filled in
   (login_hint) and comes back to the panel (?witaj=1 after "Pierwszy raz"). "Pierwszy raz" + the newsletter box: Shopify's
   newsletter form goes first (requestSubmit, so Shopify's spam check runs) and continues to the code page (return_to). */
(function () {
  var root = document.querySelector('[data-bkl]');
  if (!root) return;
  var reg = false;
  var $ = function (sel) { return root.querySelector(sel); };
  var t = $('[data-bkl-t]'), tl = $('[data-bkl-tl]'), go = $('[data-bkl-go]'), h = $('[data-bkl-h]'), nl = $('[data-bkl-nl]');
  var em = $('[data-bkl-em]'), err = $('[data-bkl-err]'), form = $('[data-bkl-form]');
  var tabs = [].slice.call(root.querySelectorAll('[data-bkl-mode]'));

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mode(r) {
    reg = r;
    tabs.forEach(function (b) { var on = (b.getAttribute('data-bkl-mode') === 'reg') === r; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    t.innerHTML = esc(t.getAttribute(r ? 'data-reg-t' : 'data-login-t')) + ' <em>' + esc(t.getAttribute(r ? 'data-reg-i' : 'data-login-i')) + '</em>';
    tl.textContent = tl.getAttribute(r ? 'data-reg' : 'data-login');
    go.textContent = go.getAttribute(r ? 'data-reg' : 'data-login');
    h.textContent = h.getAttribute(r ? 'data-reg' : 'data-login');
    nl.hidden = !r;
  }
  tabs.forEach(function (b) { b.addEventListener('click', function () { mode(b.getAttribute('data-bkl-mode') === 'reg'); }); });

  // 1.10 (Aleksandra: every log-in goes through this page): ?wroc=<path> = where to come back after the code (the cart,
  // a product...), set by snippets/batida-login-url; only a path on this shop ("/..." but not "//"), else the panel.
  // ?tryb=nowe opens "Pierwszy raz".
  var qs = new URLSearchParams(location.search);
  var wroc = qs.get('wroc') || '';
  if (!/^\/(?![\/\\])[^\s]*$/.test(wroc)) wroc = '';
  if (qs.get('tryb') === 'nowe') mode(true);

  // Clarity 7a (Aleksandra 5.10): the way back to the cart must survive the newsletter step. With "Pierwszy raz" + the
  // newsletter box, Shopify's newsletter form posts first and Shopify then reloads THIS page without ?wroc= (order #33078:
  // 19 minutes and 5 loads of this page before getting back to the cart). So: ?wroc= is remembered for 30 minutes in
  // sessionStorage (bkl-back), and when the page comes back from that post with the e-mail remembered (bkl-nl + bkl-em),
  // it goes straight on to the code page, back to the cart afterwards. Revert: delete this block and the two
  // sessionStorage lines in the submit handler (git).
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (x) { return null; } }
  if (wroc) ss('bkl-back', JSON.stringify({ p: wroc, t: Date.now() }));
  else {
    try { var bb = JSON.parse(ss('bkl-back') || 'null'); if (bb && bb.p && Date.now() - bb.t < 30 * 60 * 1000 && /^\/(?![\/\\])[^\s]*$/.test(bb.p)) wroc = bb.p; } catch (x) {}
  }

  // Clarity 7b (Aleksandra 5.10): "Kontynuuj bez konta →" when the visitor came here from the cart (or another page of
  // the shop that sent ?wroc=), back to that page. Revert: delete these lines and the link in the section.
  // 8.10 (Pat, QA sweep): "← Wróć do sklepu" goes to ?wroc= (a path on this shop) when there is one, else the home page
  var backLink = $('[data-bkl-back]'), wroc0 = qs.get('wroc') || '';
  if (backLink && /^\/(?![\/\\])[^\s]*$/.test(wroc0)) backLink.href = wroc0;
  var guest = $('[data-bkl-guest]');
  if (guest && wroc && wroc.indexOf(root.getAttribute('data-panel') || '/pages/moje-konto') !== 0) { guest.href = wroc; guest.hidden = false; }

  function loginUrl(email) {
    var u = new URL(root.getAttribute('data-login') || '/customer_authentication/login', location.origin);
    var panel = root.getAttribute('data-panel') || location.pathname;
    var back = wroc || panel;
    u.searchParams.set('return_to', back + (reg && back === panel ? (back.indexOf('?') < 0 ? '?' : '&') + 'witaj=1' : ''));
    if (!u.searchParams.get('locale')) u.searchParams.set('locale', root.getAttribute('data-locale') || 'pl');
    u.searchParams.set('login_hint', email);
    // 3.10 (Aleksandra): Shopify sends the code at once and opens the code field - no second click on its e-mail page
    u.searchParams.set('login_hint_mode', 'submit');
    return u.pathname + u.search;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = (em.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
      err.hidden = false; em.setAttribute('aria-invalid', 'true'); em.focus();
      return;
    }
    err.hidden = true; em.removeAttribute('aria-invalid');
    go.disabled = true;
    var url = loginUrl(v);
    var s1 = $('[data-bkl-step="1"]'), s2 = $('[data-bkl-step="2"]');
    if (s1 && s2) { s1.hidden = true; s2.hidden = false; }
    var cb = $('[data-bkl-nlcb]'), nf = root.querySelector('#bkl-nl-form');
    if (reg && cb && cb.checked && nf && nf.requestSubmit) {
      nf.querySelector('input[name="contact[email]"]').value = v;
      var rt = nf.querySelector('input[name="return_to"]');
      if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; nf.appendChild(rt); }
      rt.value = url;
      try { sessionStorage.setItem('bkl-nl', String(Date.now())); sessionStorage.setItem('bkl-em', v); } catch (x) {}
      nf.requestSubmit();
      return;
    }
    location.assign(url);
  });
  // Clarity 7a: back from the newsletter post -> continue to the code page at once (the "Przenosimy Cię…" step shows)
  // (only within 3 minutes of the post, so a later visit to this page never jumps on its own)
  var nlAt = parseInt(ss('bkl-nl') || '0', 10);
  var pendingEm = nlAt && Date.now() - nlAt < 3 * 60 * 1000 ? (ss('bkl-em') || '') : '';
  ss('bkl-nl', null); ss('bkl-em', null);
  if (pendingEm && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(pendingEm)) {
    reg = true;
    var p1 = $('[data-bkl-step="1"]'), p2 = $('[data-bkl-step="2"]');
    if (p1 && p2) { p1.hidden = true; p2.hidden = false; }
    location.assign(loginUrl(pendingEm));
  }
  em.addEventListener('input', function () { if (!err.hidden) { err.hidden = true; em.removeAttribute('aria-invalid'); } });
})();
